import React from 'react'
import { H, P } from '@farewill/ui'

import StrokedSteps, { StrokedStep } from 'components/StrokedSteps'

import steps from './steps'

const Steps = () => (
  <>
    <H size="L" centeredFromM decorative container containerPaddingBottom={0}>
      Make a will in three easy steps
    </H>

    <StrokedSteps>
      {steps.map(({ title, description, illustration }) => (
        <StrokedStep key={title} imagePath={`illustrations/${illustration}`}>
          <H size="S">{title}</H>
          <P>{description}</P>
        </StrokedStep>
      ))}
    </StrokedSteps>
  </>
)

export default Steps
